module.exports = __webpack_public_path__ + "7-new-year-snow.e12ab595dd82d0c4e4da.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/7-new-year-snow.png
// module id = ../../../../../src/assets/images/festival/7-new-year-snow.png
// module chunks = styles